import { ReactNode } from "react";

import Container from "@mui/material/Container";

interface LoginCardProps {
  children: ReactNode;
}

export default function LoginCard({ children }: LoginCardProps) {
  return <Container maxWidth="sm">{children}</Container>;
}
